import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const StaffOnlyRoute = ({ children }) => {
  const [isStaffOrAdmin, setIsStaffOrAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkStaffStatus();
  }, []);

  const checkStaffStatus = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        setIsStaffOrAdmin(false);
        setLoading(false);
        return;
      }

      const { data, error } = await supabase
        .from('accounts')
        .select('is_admin, is_staff')
        .eq('id', user.id)
        .single();

      if (error) throw error;
      
      // Allow access only if user is staff but NOT admin (admins use Admin Panel instead)
      setIsStaffOrAdmin(data.is_staff && !data.is_admin);
    } catch (error) {
      console.error('Error checking staff status:', error);
      setIsStaffOrAdmin(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand"></div>
    </div>;
  }

  if (!isStaffOrAdmin) {
    return <Redirect to="/user/dashboard" />;
  }

  return children;
};

export default StaffOnlyRoute;
